"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePublicService = void 0;
var constants_1 = require("../constants");
var client_1 = require("../client/client");
var BasePublicService = /** @class */ (function () {
    function BasePublicService(authorization) {
        this.client = client_1.createClient(constants_1.PUBLIC_API_URL, {
            headers: {
                Authorization: authorization
            }
        });
    }
    return BasePublicService;
}());
exports.BasePublicService = BasePublicService;
//# sourceMappingURL=base-public-service.js.map